class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if (typeof Swiper === 'undefined') {
      return;
    }
    const remPx = parseFloat(
      window.getComputedStyle(document.documentElement).fontSize
    );
    const gapRem = Number.isFinite(remPx) ? remPx : 10;

    const $worksSwiper = $('.js-topWorksSwiper');
    if ($worksSwiper.length > 0) {
      new Swiper('.js-topWorksSwiper', {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: gapRem * 1.6,
        loop: true,
        loopedSlides: 5,
        speed: 600,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.js-topWorksSwiper .swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          768: {
            spaceBetween: gapRem * 3,
          },
        },
      });
    }

    if (document.querySelector('.js-topMvPhotoSwiper')) {
      new Swiper('.js-topMvPhotoSwiper', {
        loop: true,
        loopedSlides: 3,
        slidesPerView: 1,
        allowTouchMove: false,
        simulateTouch: false,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 900,
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
        },
      });
    }
  }
}
